import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { useForm } from "react-hook-form";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Card, Popover, Row, OverlayTrigger, Col } from "react-bootstrap";
import { DashCircleFill, EyeFill, EyeSlashFill, LayerForward, Pencil, QuestionDiamondFill, Search } from "react-bootstrap-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from "react-redux";
import { searchTaxPayerInvoice, sendInvoiceToTaxOffice, taxPayerInvoiceInquiry } from "../store/api/Invoice";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
const TaxPayerInvoices = () => {
    const [inquiryResult, setInquiryResult] = useState(null);
    const [popInquiry, setpopInquiry] = useState({ Show: false });
    const [pending, setPending] = useState(false);
    const dateFilters = useRef({});
    const dispatch = useDispatch();
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const filterData = useSelector(state => state.InvoiceReducer.taxPayerSearchFilters);
    // const popInquiry = (
    //     <Popover id="popInquiry" show={showPop} style={{ fontSize: "13px", fontFamily: "Vazir", maxWidth: "400px" }}>
    //         <Popover.Title as="h3" className="headerStyle">
    //             <QuestionDiamondFill size={18} />&nbsp; استعلام وضعیت فاکتور
    //         </Popover.Title>
    //         <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
    //             {
    //                 inquiryResult === "PENDING" &&
    //                 <Loader type="BallTriangle" color="#bb1370" width={25} height={25} style={{ textAlign: "center" }} />
    //             }
    //             {inquiryResult && Array.isArray(inquiryResult) && inquiryResult.length > 0 && inquiryResult[0].data &&
    //                 <Fragment>
    //                     {inquiryResult[0].data.error && Array.isArray(inquiryResult[0].data.error) && inquiryResult[0].data.error.length > 0 &&
    //                         <div className="rowBorder mt-2" style={{ padding: "5px" }}>
    //                             <div className="rowTitle">خطاها:</div>
    //                             {inquiryResult[0].data.error.map((er, i) => <div className="mt-1" key={i} style={{ textAlign: "justify" }}>{i + 1} - {er.message}</div>)}
    //                         </div>
    //                     }
    //                     {inquiryResult[0].data.warning && Array.isArray(inquiryResult[0].data.warning) && inquiryResult[0].data.warning.length > 0 &&
    //                         <div className="rowBorder mt-4" style={{ padding: "5px" }}>
    //                             <div className="rowTitle">هشدارها:</div>
    //                             {inquiryResult[0].data.warning.map((er, i) => <div key={i} style={{ textAlign: "justify" }}>{i + 1} - {er.message}</div>)}
    //                         </div>
    //                     }
    //                 </Fragment>
    //             }
    //         </Popover.Content>
    //     </Popover>
    // )
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "تاریخ فاکتور", colName: "PContactDate", justInMobile: true },
        { colTitle: "شماره فاکتور", colName: "InvoiceNumber", justInMobile: true },
        { colTitle: "نام طرف حساب", colName: "CustomerName" },
        { colTitle: "نوع فاکتور", colName: "PInvoiceType" },
        { colTitle: "توضیحات", colName: "Description" },
        { colTitle: "ارسال شده", colName: "IsSent", colType: "boolean" },
        { colTitle: "آخرین وضعیت", colName: "PTaxInquiryStatus" }
    ]
    const tableRowButtons = [
        {
            title: "ارسال فاکتور با اطلاعات مشتری", tooltip: "ارسال فاکتور با اطلاعات مشتری", showCondition: (row) => !row.TaxInquiryStatus?.toLowerCase().includes("pending") && !row.TaxInquiryStatus?.toLowerCase().includes("success") && !row.TaxInquiryStatus?.toLowerCase().includes("foredit"),
            type: "common", icon: <LayerForward color="#0c8e91" size={19} className="rowBtn" />, className: "group-Btn-smalll btn-secondary", onclick: sendInvoice
        },
        {
            title: "ارسال فاکتور بدون اطلاعات مشتری", tooltip: "ارسال فاکتور بدون اطلاعات مشتری", showCondition: (row) => !row.TaxInquiryStatus?.toLowerCase().includes("pending") && !row.TaxInquiryStatus?.toLowerCase().includes("success") && !row.TaxInquiryStatus?.toLowerCase().includes("foredit"),
            type: "common", icon: <LayerForward color="#ff5900" size={19} className="rowBtn" />, className: "group-Btn-smalll btn-secondary", onclick: sendInvoiceWithoutCustInfo
        },        
        {
            title: "اصلاح فاکتور", tooltip: "اصلاح فاکتور", showCondition: (row) => row.TaxInquiryStatus?.toLowerCase() === "success"  || row.TaxInquiryStatus?.toLowerCase().includes("foredit") ,
            type: "common", icon: <Pencil color="#0c8e91" size={19} className="rowBtn" />, className: "group-Btn-smalll btn-secondary", 
            onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'اصلاح فاکتور',
                    dialogText: 'آیا از اصلاح فاکتور مطمئن هستید؟',
                    okOperation: ()=>sendInvoice(item)
                }))},
        },
        {
            title: "ابطال فاکتور", tooltip: "ابطال فاکتور", showCondition: (row) => row.TaxInquiryStatus?.toLowerCase() === "success"  || row.TaxInquiryStatus?.toLowerCase() === "successforedit", 
            onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'ابطال فاکتور',
                    dialogText: 'آیا از ابطال مطمئن هستید؟',
                    okOperation: ()=>cancelInvoice(item)
                }))},
            type: "common", icon: <DashCircleFill color="#fd5000" size={18} className="rowBtn" />, className: "group-Btn-smalll btn-danger"
        },
        {
            title: "استعلام فاکتور", tooltip: "استعلام فاکتور", showCondition: (row) => row.IsSent && !row.TaxInquiryStatus?.toLowerCase().includes("success"),
            type: "common", onclick: taxInquiry, icon: <QuestionDiamondFill color="#ff7800" size={19} className="rowBtn" />,
            className: "group-Btn-smalll btn-primary"
        }
    ]
    function sendInvoice(row) {
        if (pending) {
            return;
        }
        setPending(true);
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ارسال فاکتور به دارایی");
                setPending(false);
            }
            else if (res === "Success") {
                setPending(false);
                dispatch(searchTaxPayerInvoice(filterData, filterData.IsSent));
            }
        }
        sendInvoiceToTaxOffice(row.InvoiceID, row.InvoiceType, false, true, onSuccess);
    }
    function sendInvoiceWithoutCustInfo(row) {
        if (pending) {
            return;
        }
        setPending(true);
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ارسال فاکتور به دارایی");
                setPending(false);
            }
            else if (res === "Success") {
                setPending(false);
                dispatch(searchTaxPayerInvoice(filterData, filterData.IsSent));
            }
        }
        sendInvoiceToTaxOffice(row.InvoiceID, row.InvoiceType, false, false, onSuccess);
    }    
    function cancelInvoice(row) {
        if (pending) {
            return;
        }
        setPending(true);
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ابطال فاکتور");
                setPending(false);
            }
            else if (res === "Success") {
                setPending(false);
                dispatch(searchTaxPayerInvoice(filterData, filterData.IsSent));
            }
        }
        sendInvoiceToTaxOffice(row.InvoiceID, row.InvoiceType, true, true, onSuccess)
    }
    function searchInvoice(data) {
        const pDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        const pDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (pDateFrom !== "") {
            data.ContactDateFrom = dateFilters.current.ContactDateFrom;
        }
        if (pDateTo !== "") {
            data.ContactDateTo = dateFilters.current.ContactDateTo;
        }
        data.Take = 10;
        data.Skip = 0;
        dispatch(searchTaxPayerInvoice(data, data.IsSent));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function taxInquiry(invoice) {
        const onSuccess = (res) => {
            setpopInquiry({ Show: true, Target: invoice.e });
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "استعلام فاکتور");
                if (inquiryResult) {
                    setInquiryResult(null);
                }
            }
            else if (res.Data) {
                dispatch(searchTaxPayerInvoice(filterData, filterData.IsSent));
                setInquiryResult(res.Data);
            }
            else if (res === "PENDING") {
                setInquiryResult("PENDING");
            }
        }
        taxPayerInvoiceInquiry(invoice.InvoiceID, onSuccess);
    }
    useEffect(()=>{
        document.body.classList="notMain";
    },[])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;ارسال فاکتورها به دارایی
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    {
                        popInquiry.Show &&
                        <Popover id="popInquiry" style={{ fontSize: "13px", fontFamily: "Vazir", maxWidth: "400px", left: popInquiry.Target.clientX, top: popInquiry.Target.clientY - 200 }} className="mt-5">
                            <Popover.Title as="h3" className="headerStyle">
                                <span>  <QuestionDiamondFill size={18} />&nbsp; استعلام وضعیت فاکتور</span>
                                <label style={{ float: "left" }}><FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setpopInquiry({ Show: false })} /></label>
                            </Popover.Title>
                            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                                {
                                    inquiryResult === "PENDING" &&
                                    <Loader type="BallTriangle" color="#bb1370" width={25} height={25} style={{ textAlign: "center" }} />
                                }
                                {inquiryResult && Array.isArray(inquiryResult) && inquiryResult.length > 0 && inquiryResult[0].data &&
                                    <Fragment>
                                        {inquiryResult[0].data.error && Array.isArray(inquiryResult[0].data.error) && inquiryResult[0].data.error.length > 0 &&
                                            <div className="rowBorder mt-2" style={{ padding: "5px" }}>
                                                <div className="rowTitle">خطاها:</div>
                                                {inquiryResult[0].data.error.map((er, i) => <div className="mt-1" key={i} style={{ textAlign: "justify" }}>{i + 1} - {er.message}</div>)}
                                            </div>
                                        }
                                        {inquiryResult[0].data.warning && Array.isArray(inquiryResult[0].data.warning) && inquiryResult[0].data.warning.length > 0 &&
                                            <div className="rowBorder mt-4" style={{ padding: "5px" }}>
                                                <div className="rowTitle">هشدارها:</div>
                                                <div style={{ maxHeight: "300px", overflow: "auto",marginBottom:"3px" }}>
                                                    {inquiryResult[0].data.warning.map((er, i) => <div key={i} style={{ textAlign: "justify" }}>{i + 1} - {er.message}</div>)}
                                                </div>
                                            </div>
                                        }
                                    </Fragment>
                                }
                            </Popover.Content>
                        </Popover>
                    }
                    <form readOnly onSubmit={handleSubmit(searchInvoice)}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فاکتور از:</label>
                                <input type="text" className="form-control" name="InvoiceNumberFrom" ref={register({})} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>شماره فاکتور تا:</label>
                                <input type="text" className="form-control" name="InvoiceNumberTo" ref={register({})} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ فاکتور از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom"

                                    onChange={value => dateFilters.current.ContactDateFrom = value.local("en").format("YYYY-MM-DD")} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>تاریخ فاکتور تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo"
                                    onChange={val => dateFilters.current.ContactDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label>ارسال شده/نشده:</label>
                                <select className="form-control" name="IsSent" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>ارسال نشده</option>
                                    <option value={true}>ارسال شده</option>
                                </select>
                            </div>
                            <Col md={2} className="form-group">
                                <label>آخرین وضعیت ارسال: </label>
                                <select className="form-control" ref={register()} name="TaxInquiryStatus">
                                <option value="">انتخاب کنید</option>
                                <option value="failed">خطا در ارسال</option>
                                <option value="success">ارسال موفق</option>
                                <option value="pending">در صف انتظار</option>
                                <option value="failedforcancel">خطا در ابطال</option>
                                <option value="successforcancel">ابطال موفق</option>
                                <option value="pendingforcancel">در صف انتظار ابطال</option>
                                <option value="failedforedit">خطا در اصلاح</option>
                                <option value="successforedit">اصلاح موفق</option>
                                <option value="pendingforedit">در صف انتظار اصلاح</option>
                                </select>

                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mt-1"><Search size={18} />&nbsp; جستجوی فاکتور</Button>
                    </form>
                    <BihamtaTable columns={tableCols} reducerName="InvoiceReducer" objectName="taxPayerInvoices" filterData={filterData}
                        searchMethod={(data) => dispatch(searchTaxPayerInvoice(data))} hasPaging={true} rowButtons={tableRowButtons} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default TaxPayerInvoices;